var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.isError
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "error"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.hosting_error) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isError && _vm.inactiveService
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "6"
                  }
                },
                [_c("service-info")],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "6"
                  }
                },
                [
                  _c("hosting-pending", {
                    attrs: {
                      status: _vm.hosting.status
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isError && !_vm.inactiveService
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "pt-0",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      attrs: {
                        loading: _vm.loading,
                        type: "image",
                        height: "400"
                      }
                    },
                    [
                      _c("router-view", {
                        attrs: {
                          loading: _vm.loading
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }